import axios from 'axios'

// 创建axios实例
// 开发环境：使用环境变量配置的API地址
// 生产环境：使用相对路径 /api，由Nginx反向代理
const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/api' : (process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api'),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 可以在这里添加token等认证信息
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    console.error('API请求错误:', error)
    return Promise.reject(error)
  }
)

export default api